import Noty from 'noty';

import '@vendor/noty.css';

export default {
  send: function (options = {}) {
    var speed = options['fast'] ? '_fast' : '';

    options['type'] = options['type'] || 'alert';
    options['theme'] = 'nest';
    options['killer'] = true;
    options['layout'] = options['layout'] || 'topCenter';
    options['timeout'] = options['timeout'] == false ? false : options['timeout'] || 3500;
    options['closeWith'] = options['closeWith'] || ['button', 'click'];
    options['animation'] = {
      open: `animated noty_effects_open${speed}`,
      close: `animated noty_effects_close`,
    };

    return new Noty(options).show();
  },
};
